/**
 * Checks if the current browser is any version of internet explorer
 * (including IE11, excluding Edge).
 * Answer taken from https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie/21712356#21712356
 */
export default {
  isInternetExplorer() {
    const ua = window.navigator.userAgent;
    return /MSIE|Trident/.test(ua);
  },
};
